import React from "react";
import { Modal } from "react-bootstrap";
import { config } from "../../Constants";
import { FormattedMessage } from "react-intl";

const LoginModal = ({ show, handleClose, isMobile }) => {
  const LoginAsDoctor = () => {
    if (isMobile) {
      window.location.href = "/doctorlogin";
    } else {
      window.location.href = config.url.WEB_URL + "Identity/Account/Login";
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="modal-content p-2">
        <div
          className="modal-header border-0 d-flex justify-content-end"
          style={{ padding: "13px" }}
        >
          <span
            className="close-text"
            style={{ cursor: "pointer" }}
            onClick={handleClose}
            role="button"
          >
            <FormattedMessage id="Close" /> &#10006;
          </span>
        </div>

        <div
          className="modal-body d-flex justify-content-around text-center"
          style={{ padding: "13px" }}
        >
          <div>
            <h5 style={{ marginBottom: "13px" }}>
              <FormattedMessage id="LoginAsPatient" />
            </h5>
            <a
              className="btn btn-dark-blue pt-1"
              style={{
                padding: "3px 13px",
                lineHeight: "2.3",
                fontSize: "16px",
              }}
              href="/login"
              id="patientLoginButton"
            >
              <FormattedMessage id="Patient" />
            </a>
          </div>

          <div>
            <h5 style={{ marginBottom: "13px" }}>
              <FormattedMessage id="LoginAsDoctor" />
            </h5>
            <a
              className="btn btn-dark-blue pt-1"
              style={{
                padding: "3px 13px",
                lineHeight: "2.3",
                fontSize: "16px",
              }}
              onClick={LoginAsDoctor}
              id="doctorLoginButton"
            >
              <FormattedMessage id="Doctor" />
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
